(function () {
    'use strict';

    function siteConfigurationsController($scope, $route, $routeParams, $location, configurationDataService) {
        var self = this;

        this.siteConfigurations = [];

        this.init = function () {
            self.loadAllConfigurations();
        };


        this.loadAllConfigurations = function () {
            return configurationDataService.loadAllConfigurations().then(function (data) {
                self.siteConfigurations = data;
            });
        };

        this.init();
    }

    siteConfigurationsController.$inject = ['$scope', '$route', '$routeParams', '$location', 'configurationDataService'];

    angular.module('ecap.siteConfiguration').controller('siteConfigurationsController', siteConfigurationsController);
})();
